<!-- Only used from home search view when CSV is called - consider replacing with caseReportTable-->
<template>
  <v-data-table
    :headers="headers"
    :items="caseReports"
    :items-per-page="10"
    item-key="id"
    :loading="loading"
    :search="search"
    no-data-text="No matches."
  >
    <template v-slot:top>
      <v-toolbar flat>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
        <v-spacer />
      </v-toolbar>
    </template>

    <template v-slot:item.matches="{ item }">
      <v-chip
        small
        outlined
        v-if="item.matches.length > 0"
        class="ma-2"
        color="red"
        text-color="red"
        >{{ item.matches.length }}</v-chip
      >
      <v-chip
        small
        outlined
        v-else
        class="ma-2"
        color="green"
        text-color="green"
        >0</v-chip
      >
    </template>

    <template v-slot:item.dob="{ item }">
      {{ formatDate(item.searchCase.dob) }}
    </template>

    <template v-slot:item.status="{ item }">
      <ResolutionStatusChips :resolutionStatus="item.status" />
    </template>

    <template v-slot:item.searchDate="{ item }">
      {{ formatDateTime(item.searchDate) }}
    </template>

    <template v-slot:item.controls="{ item }">
      <v-btn fab dark x-small color="blue" @click="onViewClick(item)">
        <v-icon dark>mdi-export</v-icon>
      </v-btn>
    </template>
  </v-data-table>
</template>

<script>
import { formatDate, formatDateTime } from "../utils/dateUtils";
import ResolutionStatusChips from "../components/ResolutionStatusChips";
export default {
  name: "CasesTable",
  components: { ResolutionStatusChips },
  data() {
    return {
      search:"",
      headers: [
        { text: "Case Name", value: "searchCase.name" },
        { text: "DOB", value: "dob", sortable: false },
        { text: "Matches", value: "matches" },
        { text: "Status", value: "status" },
        {
          text: "View",
          value: "controls",
          sortable: false,
          filterable: false,
          align: "right",
        },
      ],
    };
  },
  props: {
    caseReports: {},
    tableClass: {},
    loading: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    formatDate,
    formatDateTime,
    onViewClick(caseReport) {
      this.$emit("onViewCaseReport", caseReport);
    }
  }
};
</script>